var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.04,
    height: 25.468,
    viewBox: "0 0 32.04 25.468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail_outline",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M13.4,21.6H23.439a45.05,45.05,0,0,1,5.483.191A6.108,6.108,0,0,1,32.635,23.4a6.108,6.108,0,0,1,1.613,3.713A45.076,45.076,0,0,1,34.44,32.6v3.467a45.077,45.077,0,0,1-.191,5.483,6.108,6.108,0,0,1-1.613,3.713,6.108,6.108,0,0,1-3.713,1.613,45.078,45.078,0,0,1-5.483.191H13.4a45.077,45.077,0,0,1-5.483-.191A6.108,6.108,0,0,1,4.2,45.263,6.108,6.108,0,0,1,2.591,41.55,45.049,45.049,0,0,1,2.4,36.067V32.6a45.048,45.048,0,0,1,.191-5.483A6.108,6.108,0,0,1,4.2,23.4a6.108,6.108,0,0,1,3.713-1.613A45.049,45.049,0,0,1,13.4,21.6ZM8.246,24.234a3.7,3.7,0,0,0-2.3.913,3.7,3.7,0,0,0-.913,2.3,44.137,44.137,0,0,0-.169,5.244v3.286a44.139,44.139,0,0,0,.169,5.245,3.7,3.7,0,0,0,.913,2.3,3.7,3.7,0,0,0,2.3.913,44.163,44.163,0,0,0,5.244.169h9.858a44.164,44.164,0,0,0,5.245-.169,3.7,3.7,0,0,0,2.3-.913,3.7,3.7,0,0,0,.913-2.3,44.164,44.164,0,0,0,.169-5.245V32.691a44.163,44.163,0,0,0-.169-5.244,3.7,3.7,0,0,0-.913-2.3,3.7,3.7,0,0,0-2.3-.913,44.139,44.139,0,0,0-5.245-.169H13.491A44.137,44.137,0,0,0,8.246,24.234Z",
    transform: "translate(-2.4 -21.6)",
    fill: "#54a19e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M31.406,60.548a1.232,1.232,0,0,1,1.709-.342l4.39,2.927c1.348.9,2.278,1.516,3.054,1.92a3.124,3.124,0,0,0,3.462,0c.776-.4,1.706-1.022,3.054-1.92l4.39-2.927a1.232,1.232,0,0,1,1.367,2.051l-4.447,2.965a38.056,38.056,0,0,1-3.227,2.018,5.532,5.532,0,0,1-5.737,0,38.042,38.042,0,0,1-3.227-2.018l-4.447-2.965A1.232,1.232,0,0,1,31.406,60.548Z",
    transform: "translate(-26.27 -53.427)",
    fill: "#54a19e",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOutline);
export default __webpack_public_path__ + "static/media/mail_outline.98b997686bac3cc618c08a2c54c1db87.svg";
export { ForwardRef as ReactComponent };